module.exports = __webpack_public_path__ + "img/2015-min.865bf7e3.jpg";